/*
 * AU prescription fields: the PBS/RPBS details printed onto the pre-printed Services Australia
 * prescription form (PB023). Everything the medication modal needs to know about them lives here,
 * so the shared medication form and tile only ever call PrescriptionFieldsService.
 *
 * Field names are the snake_case the medication API uses.
 */
app.service("AuPrescriptionFieldsService", [
	function () {
		function isAuthority(source) {
			return !!(source && (source.pbs_authority_number || source.streamlined_authority_code));
		}

		function trimmedOrNull(value) {
			return value ? String(value).trim() : null;
		}

		return {
			// A PBS item cannot be added without a quantity; the form also marks the field as required.
			isComplete: function (form) {
				return form.quantity != null && form.quantity !== "";
			},

			// The PBS fields stored on a medication added from the form. Authority fields are only kept
			// when an authority number or streamlined code was entered, so a standard item has none.
			fromForm: function (form) {
				const authority = isAuthority(form);
				return {
					quantity: form.quantity != null && form.quantity !== "" ? Number(form.quantity) : null,
					repeats: form.repeats != null && form.repeats !== "" ? Number(form.repeats) : 0,
					brand_substitution_not_permitted: !!form.brand_substitution_not_permitted,
					pbs_authority_number: authority ? trimmedOrNull(form.pbs_authority_number) : null,
					streamlined_authority_code: authority ? trimmedOrNull(form.streamlined_authority_code) : null,
					authority_indication: authority ? trimmedOrNull(form.authority_indication) : null,
					previous_authority: authority ? !!form.previous_authority : null,
				};
			},

			reset: function (form) {
				form.quantity = null;
				form.repeats = null;
				form.brand_substitution_not_permitted = false;
				form.pbs_authority_number = null;
				form.streamlined_authority_code = null;
				form.authority_indication = null;
				form.previous_authority = false;
			},

			// The PBS fields sent with a medication when the prescription is generated.
			toPayload: function (medication) {
				return {
					quantity: medication.quantity,
					repeats: medication.repeats,
					brand_substitution_not_permitted: medication.brand_substitution_not_permitted,
					pbs_authority_number: medication.pbs_authority_number,
					streamlined_authority_code: medication.streamlined_authority_code,
					authority_indication: medication.authority_indication,
					previous_authority: medication.previous_authority,
				};
			},

			// One line for the "Selected medications" list.
			summary: function (medication) {
				const parts = [
					"Qty: " + (medication.quantity != null ? medication.quantity : ""),
					"Repeats: " + (medication.repeats > 0 ? medication.repeats : "Nil"),
				];
				if (medication.brand_substitution_not_permitted) {
					parts.push("Brand substitution not permitted");
				}
				if (isAuthority(medication)) {
					let authority = "Authority: " + (medication.pbs_authority_number || "");
					if (medication.streamlined_authority_code) {
						authority += " (streamlined " + medication.streamlined_authority_code + ")";
					}
					parts.push(authority);
				}
				return parts.join("; ");
			},
		};
	},
]);
